import { gate } from 'hub-http/gates';
// v3 gates - https://product.hubteam.com/docs/gating/next-gen/usage.html#frontend-usage

export const TRI_TEMPORARY_DISCOUNT = gate('TRI::TemporaryDiscount');
export const UBX_CREDIT_ESTIMATION = gate('UBX:CreditEstimation');
export const PPIA_SALESBOT = gate('PPIA:SalesBot');
export const HSOC_CALCULATOR = gate('PPFE:HSOCCalculator');
export const HSOC_CALCULATOR_FLAG = 'HSOC_CALCULATOR_FLAG';